module.exports = '<div class="linkedin">\n    Linkedin\n</div>\n\n';